import Head from 'next/head';
import { TFunction } from 'next-i18next';
import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CONDITION_DESKTOP } from 'shared/common/constants';
import { routes } from 'shared/common/routes';
import styled from 'styled-components';
import { MainLayout } from 'widgets/layouts';

import { academyQuestions } from './academy-questions';
import { AnswersList, QuestionsGrid } from './ui';

const getNavbar = (t: TFunction) => [
  {
    text: t('defaultNavbar.findExperts'),
    href: routes.topics,
  },
  {
    text: t('defaultNavbar.becomeExpert'),
    href: routes.expertLanding,
  },
];

export const Academy: FC = () => {
  const { t } = useTranslation('header.component');

  return (
    <MainLayout hasFooter head={{ title: 'Академия экспертов Consulty' }} navbar={getNavbar(t)} isLoginButtonVisible>
      <Head>
        <meta name="title" content="Академия экспертов Consulty" />
        <meta name="description" content="Как работать с сервисом и стать лучшим экспертом! 💪" />
        <meta name="og:title" content="Академия экспертов Consulty" />
        <meta name="og:site_name" content="www.consulty.online" />
        <meta name="og:url" content="https://www.consulty.online/academy/" />
        <meta name="og:description" content="Как работать с сервисом и стать лучшим экспертом! 💪" />
        <meta name="og:image" content="/img/social.jpg" />
      </Head>

      <h1 className="hidden">{t('head.title')}</h1>
      <Content className="container">
        <Title>Академия экспертов Consulty</Title>
        <Subtitle>Как работать с сервисом и стать лучшим экспертом! 💪</Subtitle>
        <QuestionsGrid
          list={academyQuestions.map((item) => ({
            icon: item.icon,
            title: item.title,
            questions: item.questions,
          }))}
        />
        <AnswersList
          list={academyQuestions.map((item) => ({
            icon: item.icon,
            title: item.title,
            questions: item.questions,
          }))}
        />
      </Content>
    </MainLayout>
  );
};

const Content = styled.main``;

const Title = styled.h2`
  font-size: 24px;
  color: var(--black2);
  padding: 30px 0 10px;
  ${CONDITION_DESKTOP} {
    padding-top: 60px;
    text-align: center;
    font-size: 42px;
  }
`;

const Subtitle = styled.p`
  font-size: 15px;
  ${CONDITION_DESKTOP} {
    text-align: center;
    font-size: 17px;
  }
`;
